import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Clock from '@zocdoc-frontend-common/assets-icons/Clock';
import { Tooltip, TOOLTIP } from '@zocdoc-frontend-common/components-tooltip';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

import { APPOINTMENT_TIME_STRINGS, TooltipParams } from './constants';

const TimesGridTooltipWrapper = ({ isMobile, timesgrid }) => {
    let tooltipParams;
    if (isMobile) {
        tooltipParams = TooltipParams[TOOLTIP.BOTTOM];
    } else {
        tooltipParams = TooltipParams[TOOLTIP.RIGHT];
    }

    return (
        <div>
            <StyledTooltip
                anchor={timesgrid}
                showTooltip
                tooltipPosition={tooltipParams.tooltipPosition}
            >
                <Header>
                    <Icon>
                        <Clock height={18} />
                    </Icon>
                    <Text>{APPOINTMENT_TIME_STRINGS.Oops}</Text>
                </Header>
                <Body>{APPOINTMENT_TIME_STRINGS.NoLongerAvailable}</Body>
            </StyledTooltip>
        </div>
    );
};

TimesGridTooltipWrapper.propTypes = {
    isMobile: PropTypes.bool,
    timesgrid: PropTypes.object,
};

export const StyledTooltip = styled(Tooltip)`
    margin-left: 50%;
    transform: translateX(-50%);
    width: 250px;
`;

const Header = styled.div`
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    padding-top: 1px;
    padding-bottom: 3px;
    width: 100%;
`;

const Body = styled.div`
    font: 14px/24px ${FontFamily.KievitSlabBook};
    margin-left: 12px;
`;

const Icon = styled.div`
    display: inline-block;
    height: 19.1px;
    width: 17.9px;
`;

const Text = styled.div`
    display: inline-block;
    margin-left: 10px;
    margin-top: 0;
    vertical-align: top;
`;

export default TimesGridTooltipWrapper;
